import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'features/store';
import { DataLists } from 'services/data/data.types';

export type DatalistsState = {
    datalists: DataLists | null;
};

const initialDatalistsState: DatalistsState = {
    datalists: null
};

export const datalistsSlice = createSlice({
    name: 'datalists',
    initialState: initialDatalistsState,
    reducers: {
        setDatalists: (state, action: PayloadAction<DataLists>) => {
            state.datalists = action.payload;
        }
    }
});

export const getDatalists = (state: RootState) => state.datalists;
export const { setDatalists } = datalistsSlice.actions;

export default datalistsSlice.reducer;
